import React from 'react';
import { ContainerStyles } from './Container.style';

/**
 * Container component
 */
const Container = ({ ...props }) => <ContainerStyles {...props} />;

export default Container;
